// extracted by mini-css-extract-plugin
module.exports = {"container":"_99551c8aa8--container--UpinP","text":"_99551c8aa8--text--uBivY"};